import { ActivatedRoute } from "@angular/router";

// Routes where the header/footer should be hidden:
// - Bizcuit embedded view
// - Generic external embed paths
const NOT_VISIBLE_EXCEPTIONS = [
  '/external/',
  '/oauthresult',
  '/bizcuit'
];

export const headerFooterVisible = (activatedRoute: ActivatedRoute): boolean =>
    !NOT_VISIBLE_EXCEPTIONS.some(e => activatedRoute.toString().includes(e));
